module.exports = __webpack_public_path__ + "static/media/CV.87c26912.pdf";